export default __webpack_public_path__ + "static/ovo-e8a235168f6b9f1af99a1c46be226a13.png";